import InsiderHubSourceStylePage from "@faire/prototype-playground/workspace/mw/insider-hub-source-style";
import InsiderMinimumMilestoneInCartPage from "@faire/prototype-playground/workspace/mw/insider-minimum-milestone-in-cart";
import { Route, Switch } from "react-router-dom";

export function MarkWidishRoutes() {
  return (
    <Switch>
      <Route
        path="/mw/insider-hub-source-style"
        component={InsiderHubSourceStylePage}
      />
      <Route
        path="/mw/insider-minimum-milestone-in-cart"
        component={InsiderMinimumMilestoneInCartPage}
      />
    </Switch>
  );
}

export const slug = "mw";
